export default __webpack_public_path__ + "static/media/priscilla1.bb2528e5.jpg";